import { css } from '@emotion/react';
import { useDevToolsStore } from '@frontend/devtools';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../constants';
import { useCalendarGridStore } from '../store/calendar-grid.store';

export const DebugControls = () => {
  const shouldShowControls = useDevToolsStore((state) => state.options.isDebugModeOn);
  const { groupIds, groupsById, columnsById, eventsById } = useCalendarGridStore([
    'groupIds',
    'groupsById',
    'columnsById',
    'eventsById',
  ]);
  if (!shouldShowControls) {
    return null;
  }

  const handleInfoClick = () => {
    console.log('Calendar Grid Debug Info:', {
      groupIds,
      groupInfo: groupIds.map((groupId) => {
        return {
          ...groupsById[groupId],
          columns: groupsById[groupId]?.columnIds.map((columnId) => {
            return {
              ...columnsById[columnId],
              events: columnsById[columnId]?.eventIds.map((eventId) => eventsById[eventId]),
            };
          }),
        };
      }),
    });
  };

  return (
    <div data-debug-controls css={containerStyle}>
      <Button size='tiny' variant='secondary' iconName='info' onClick={handleInfoClick} />
    </div>
  );
};

const containerStyle = css({
  backgroundColor: theme.colors.neutral5,
  boxShadow: theme.shadows.light,
  zIndex: CALENDAR_Z_INDICES.debugControls,
  position: 'absolute',
  top: 0,
  right: 0,
  opacity: 0.5,
  '&:hover': {
    opacity: 1,
  },
});
